export const SpineRegions = {
  CERVICAL: "Cervical",
  THORACIC: "Thoracic",
  LUMBAR: "Lumbar",
  SACRAL: "Sacral",
  LOWER_BODY: "Lower Body",
  FULL_BODY: "Full Body",
  FULL_SPINE: "Full Spine",
};

export const MacroRegions = {
  SPINE: "spine",
  LOWER_BODY: "lower_body",
  ENDPLATES: "endplates",
};
